//import { Subject } from 'rxjs/Subject';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Candidates } from '../models/candidates.model';
import { Companies } from '../models/companies.model';
import { Admins } from '../models/admins.model';
import { Consultants } from '../models/consultants.model';

@Injectable()
export class UsersService {
  
    constructor(private httpClient: HttpClient) { }
  
    getCurrentUser(): any {
        if (localStorage.getItem('currentCandidate') != undefined) {
            const dataString: any = localStorage.getItem('currentCandidate');
            let currentCandidate = new Candidates(JSON.parse(dataString));
            
            return currentCandidate;
        } else if (localStorage.getItem('currentConsultant') != undefined) {
            const dataString: any = localStorage.getItem('currentConsultant');
            let currentConsultant = new Consultants(JSON.parse(dataString));

            return currentConsultant;
        } else if (localStorage.getItem('currentCompany') != undefined) {
            const dataString: any = localStorage.getItem('currentCompany');
            let currentCompany = new Companies(JSON.parse(dataString));

            return currentCompany;
        } else if (localStorage.getItem('currentAdmin') != undefined) {
            const dataString: any = localStorage.getItem('currentAdmin');
            let currentAdmin = new Admins(JSON.parse(dataString));

            return currentAdmin;
        }
        
        return undefined;
    }
    
    isAuth(): boolean {
        if (this.getCurrentUser() != undefined) {
            return true;
        }
        
        return false;
    }
    
    getUserType() : string {
        if (localStorage.getItem('currentCandidate') != undefined) {
            return 'candidat';
        } else if (localStorage.getItem('currentConsultant') != undefined) {
            return 'consultant';
        } else if (localStorage.getItem('currentCompany') != undefined) {
            return 'entreprise';
        } else if (localStorage.getItem('currentAdmin') != undefined) {
            return 'admin';
        } else {
            return '';
        }
    }
}